import { useMemo } from 'react'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import { Header } from 'app/KinerjaShared/components/Header'
import { useAPIGetPenilaianPeriodik } from 'api/kinerja/tim-penilai-ps/penilaian-periodik'
import { TablePeriodik } from 'app/KinerjaShared/components/Periodik/TablePeriodik'
import useBasePath from 'app/KinerjaTimPenilaiPSPage/hooks/useBasePath'
import { PANDUAN_PENILAIAN_PERIODIK_PS_PEGAWAI_URL } from 'app/KinerjaShared/utils/panduan'

export default function PenilaianPeriodikList() {
  const { basePath } = useBasePath()
  const { data, isLoading } = useAPIGetPenilaianPeriodik()
  const items = useMemo(() => {
    return (data?.periode ?? []).map((periode) => ({
      month: periode.bulan,
      label: periode.labelPeriode,
      state: periode.status,
      startingDate: (periode.tanggalMulaiPenilaian ?? '').split('T')[0],
      endingDate: (periode.tanggalKirimOtomatis ?? '').split('T')[0],
    }))
  }, [data?.periode])

  return (
    <div className="min-h-full px-8 pt-12 pb-8 bg-gray-10">
      <div className="pb-12 mx-auto max-w-7xl">
        <Header
          title="Penilaian Periodik"
          className="my-6"
          rightNode={
            <div>
              <Button
                variant="ghost"
                size="lg"
                as="a"
                type={undefined}
                className="!bg-white flex items-center space-x-1 text-blue-70"
                // TODO: change URL
                href={PANDUAN_PENILAIAN_PERIODIK_PS_PEGAWAI_URL}
                target="blank"
              >
                <Icon color="inherit">help</Icon>
                <Text as="span" variant="action" color="inherit">
                  Cek Pusat Informasi
                </Text>
              </Button>
            </div>
          }
        />

        <div className="flex p-4 mb-6 space-x-1 border rounded-md border-interactive-default bg-surface-informational-subdued">
          <Icon>info</Icon>
          <Text>
            Data Penilaian Periodik untuk periode sebelumnya sudah tersedia dan
            hanya dapat dicek di E-Kinerja.
          </Text>
        </div>

        <TablePeriodik
          isLoading={isLoading}
          items={items}
          nextPageResolver={(month) =>
            `${basePath}/penilai/penilaian/periodik/${month}`
          }
        />
      </div>
    </div>
  )
}
